module.exports = __webpack_public_path__ + "img/cb-search.b107bae6.svg";